"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleChannelSpiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function appleChannelSpiClient(networkClient) {
    return {
        syncAsrCampaign: async (params) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-results/sync`, {});
        },
        syncAstCampaign: async (params) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/sync`, {});
        },
        exportTeamChannels: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/spi/v2/apple-channels/teams/${params.teamId}/channels`, query);
        },
        exportChannels: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/spi/v2/apple-channels/campaigns/${params.campaignId}/channels`, query);
        },
        exportChannelRefs: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/spi/v2/apple-channels/campaigns/${params.campaignId}/channels/refs`, query);
        },
        upliftBudgetInCampaign: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/spi/v2/apple-channels/campaigns/${params.campaignId}/budgets/campaigns`, body);
        },
        upliftBudgetInRegion: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/spi/v2/apple-channels/campaigns/${params.campaignId}/budgets/regions`, body);
        },
        findByPlatformRef: async (query) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/spi/v2/apple-channels/platform-campaigns`, query);
        },
        updateCampaignBids: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/spi/v2/apple-channels/campaigns/${params.campaignId}/bids`, body);
        },
        sendSyncAppleChannel: (message) => {
            return networkClient.fireToTopic(data_lib_1.SYNC_APPLE_CHANNEL_TOPIC, message, "Unable to send sync apple channel message message, error=");
        },
        sendScheduledChangesAppleChannel: (message) => {
            return networkClient.fireToTopic(data_lib_1.SCHEDULED_CHANGES_APPLE_CHANNEL_TOPIC, message, "Unable to send scheduled changes apple channel message message, error=");
        },
        getChannelSpendDetails: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/spi/v2/apple-channels/campaigns/${params.campaignId}/budgets/spend`, query);
        },
        getKeywordRefToKeywordMapping: async (body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/spi/v2/apple-channels/keyword-ref-mappings`, body);
        },
    };
}
exports.appleChannelSpiClient = appleChannelSpiClient;
